import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { reduxBatch } from '@manaflair/redux-batch'

import {
  uiSlice,
  jobSettingsSlice,
  roofSlice,
  settingsSlice,
  wallSlice,
  resultSlice,
} from './slices'

import { saveAppState } from '../common/fns'

import { createQuery, handleCalculationActions, handleAppEvents } from './middlewares'

import { getGlobalReducers } from '../../../utils/reducers'

import throttle from 'lodash/throttle'

const inputReducer = combineReducers({
  [settingsSlice.name]: settingsSlice.reducer,
  [jobSettingsSlice.name]: jobSettingsSlice.reducer,
  [roofSlice.name]: roofSlice.reducer,
  [wallSlice.name]: wallSlice.reducer,
})

const outputReducer = combineReducers({
  [resultSlice.name]: resultSlice.reducer,
})

const calculationReducer = combineReducers({
  input: inputReducer,
  output: outputReducer,
})

const globalReducers = getGlobalReducers()

const rootReducer = combineReducers({
  [uiSlice.name]: uiSlice.reducer,
  calculation: calculationReducer,
  ...globalReducers,
})

export const makeStore = (preloadedState) => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
    enhancers: [reduxBatch],
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(createQuery, handleCalculationActions, handleAppEvents),
  })

  store.subscribe(
    throttle(() => {
      saveAppState(store.getState())
    }, 1000),
  )

  return store
}
